import { useState } from 'react'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { assertFulfilled } from './utils'

type ProductResponse = {
  Id: number
  Name: string
}

export function useProductsImport() {
  const [loading, setLoading] = useState(false)

  const { fetcherWrapper } = useFetch()

  function getProduct(id: string): Promise<Item> {
    const url = new URL(
      `/api/proxy/catalog/pvt/product/${id}`,
      window.location.origin
    )

    return fetcherWrapper(url)
      .then((r) => {
        if (r.status === 404) return Promise.reject('Not found')
        if (!r.ok) return Promise.reject('Error retrieving product')

        return r.json()
      })
      .then((response: ProductResponse) => ({
        id: response.Id.toString(),
        name: response.Name,
      }))
  }

  async function importProducts(
    ids: string[]
  ): Promise<{ items: Item[]; found: number; notFound: number }> {
    setLoading(true)

    const promises = ids.map((id) => getProduct(id))

    const products = await Promise.allSettled(promises).then((resuls) => {
      return resuls.filter(assertFulfilled).map((r) => r.value)
    })

    setLoading(false)

    return {
      found: products.length,
      notFound: ids.length - products.length,
      items: products,
    }
  }

  return { importProducts, loading }
}
